/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Devices_NoneInputs */

const th_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีเบราว์เซอร์ที่ลงทะเบียน เปิดการแจ้งเตือนด้านบน`)
};

const en_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No browser is registered yet. Turn notifications on above.`)
};

const ja_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録されたブラウザはまだありません。上で通知をオンにしてください。`)
};

const zh_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未注册任何浏览器。请在上面打开通知。`)
};

const es_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay ningún navegador registrado. Activa las notificaciones arriba.`)
};

const pt_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum navegador registrado ainda. Ligue as notificações acima.`)
};

const id_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada peramban yang terdaftar. Nyalakan notifikasi di atas.`)
};

const fr_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun navigateur enregistré pour l’instant. Activez les notifications ci-dessus.`)
};

const tl_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang nakarehistrong browser. Buksan ang mga notipikasyon sa itaas.`)
};

const vi_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có trình duyệt nào được đăng ký. Bật thông báo ở trên.`)
};

const ko_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록된 브라우저가 아직 없습니다. 위에서 알림을 켜세요.`)
};

const de_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Browser registriert. Aktiviere die Benachrichtigungen oben.`)
};

const ru_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ни один браузер ещё не зарегистрирован. Включите уведомления выше.`)
};

const tr_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz kayıtlı tarayıcı yok. Yukarıdan bildirimleri açın.`)
};

const it_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun browser ancora registrato. Attiva le notifiche qui sopra.`)
};

const pl_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie zarejestrowano jeszcze żadnej przeglądarki. Włącz powiadomienia powyżej.`)
};

const uk_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жодного браузера ще не зареєстровано. Увімкніть сповіщення вище.`)
};

const hi_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई ब्राउज़र दर्ज नहीं है। ऊपर सूचनाएँ चालू करें।`)
};

const ar_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يُسجَّل أي متصفح بعد. فعّل الإشعارات أعلاه.`)
};

const ms_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pelayar didaftarkan. Hidupkan pemberitahuan di atas.`)
};

const bn_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও ব্রাউজার নিবন্ধিত নয়। উপরে বিজ্ঞপ্তি চালু করুন।`)
};

const zh_tw2_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未註冊任何瀏覽器。請在上方開啟通知。`)
};

const zh_hk2_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未註冊任何瀏覽器。請在上方開啟通知。`)
};

const ur_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی براؤزر درج نہیں۔ اوپر اطلاعات چالو کریں۔`)
};

const fa_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز هیچ مرورگری ثبت نشده. اعلان‌ها را در بالا روشن کنید.`)
};

const sw_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna kivinjari kilichosajiliwa bado. Washa arifa hapo juu.`)
};

const nl_devices_none = /** @type {(inputs: Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen browser geregistreerd. Zet de meldingen hierboven aan.`)
};

/**
* | output |
* | --- |
* | "No browser is registered yet. Turn notifications on above." |
*
* @param {Devices_NoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const devices_none = /** @type {((inputs?: Devices_NoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Devices_NoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_devices_none(inputs)
	if (locale === "ja") return ja_devices_none(inputs)
	if (locale === "zh") return zh_devices_none(inputs)
	if (locale === "es") return es_devices_none(inputs)
	if (locale === "pt") return pt_devices_none(inputs)
	if (locale === "id") return id_devices_none(inputs)
	if (locale === "fr") return fr_devices_none(inputs)
	if (locale === "tl") return tl_devices_none(inputs)
	if (locale === "vi") return vi_devices_none(inputs)
	if (locale === "ko") return ko_devices_none(inputs)
	if (locale === "de") return de_devices_none(inputs)
	if (locale === "ru") return ru_devices_none(inputs)
	if (locale === "tr") return tr_devices_none(inputs)
	if (locale === "it") return it_devices_none(inputs)
	if (locale === "pl") return pl_devices_none(inputs)
	if (locale === "uk") return uk_devices_none(inputs)
	if (locale === "hi") return hi_devices_none(inputs)
	if (locale === "ar") return ar_devices_none(inputs)
	if (locale === "ms") return ms_devices_none(inputs)
	if (locale === "bn") return bn_devices_none(inputs)
	if (locale === "zh-TW") return zh_tw2_devices_none(inputs)
	if (locale === "zh-HK") return zh_hk2_devices_none(inputs)
	if (locale === "ur") return ur_devices_none(inputs)
	if (locale === "fa") return fa_devices_none(inputs)
	if (locale === "sw") return sw_devices_none(inputs)
	if (locale === "nl") return nl_devices_none(inputs)
	return en_devices_none(inputs)
});